import React from 'react';
import { EmailVerificationOutlineIcon, PhoneVerificationIcon,  } from '@common-fe/common-fe';

import { MFAChannelType } from '@/modules/user/components/SignIn/MultiFactorAuthentication/mfa.types';

interface MFAChannelDescription {
  icon: React.ReactNode;
  name: string;
}

const useMFAChannelsDescription = (channelType?: MFAChannelType): MFAChannelDescription => {
  switch (channelType) {
  case MFAChannelType.EMAIL:
    return {
      icon: <EmailVerificationOutlineIcon data-testId="verification-code-modal_email-icon" size="128px" />,
      name: 'Email Verification',
    };
  case MFAChannelType.SMS: 
    return {
      icon: <PhoneVerificationIcon data-testId="verification-code-modal_phone-icon" size="128px" />,
      name: 'Phone Verification',
    };
  default:
    return {
      icon: <></>,
      name: '',
    };
  }
};

export default useMFAChannelsDescription;
